import { render, staticRenderFns } from "./MatrixAnswer.vue?vue&type=template&id=e5877478&scoped=true&"
import script from "./MatrixAnswer.vue?vue&type=script&lang=js&"
export * from "./MatrixAnswer.vue?vue&type=script&lang=js&"
import style0 from "./MatrixAnswer.vue?vue&type=style&index=0&id=e5877478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5877478",
  null
  
)

export default component.exports